import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = {
  class: "text pad20",
  style: {"color":"#696969"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fs13 fw600 ddgrey text-left pad10" }, " 確定する情報を設定します。事前に設定することで、確定一覧やメールで内容を確認しやすくなります。 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_5 = { class: "w100" }
const _hoisted_6 = {
  key: 0,
  class: "w40 mb20"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "fs14 fw600" }, "確定するイベント情報", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "fl mr6 mb5" }
const _hoisted_12 = { class: "fs13 fw600 mt20" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_ctx.fixedAppoDic.f_appo)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_MdTextfieldTag, {
                name: "タイトル",
                style: {"height":"56px","min-width":"100%"},
                fieldStyle: "min-width:100%;",
                class: "fl fs14 mb5",
                value: _ctx.fixedAppoDic.f_appo.name,
                onInputValue: _ctx.inputAppoName
              }, null, 8, ["value", "onInputValue"]),
              _hoisted_8
            ]))
          : _createCommentVNode("", true),
        _hoisted_9,
        (_ctx.attendees && _ctx.fixedAppoDic.f_members)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fixedAppoDic.f_members, (mem, memindex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "w20 rad20 pad20 llgreyBg fl mb20 mr20",
                  key: memindex
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_UserIcon, {
                      member: mem,
                      width: 38,
                      canEdit: false,
                      updateSelf: false,
                      showTooltip: false
                    }, null, 8, ["member"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createTextVNode("元の名前: " + _toDisplayString(_ctx.attendees?.find(att => att.id == mem.id)?.name), 1),
                    _hoisted_13
                  ]),
                  _createVNode(_component_MdTextfieldTag, {
                    name: "これからの名前",
                    style: {"height":"56px","min-width":"100%"},
                    fieldStyle: "min-width:100%;",
                    class: "fl fs14 mb5",
                    value: mem.name,
                    onInputValue: ($event: any) => (_ctx.inputMemberName($event, mem.id))
                  }, null, 8, ["value", "onInputValue"]),
                  _hoisted_14
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}